import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { SearchType } from '../../types';

import { deployHistoryDistinct } from '~/api/runtimeService';

export function useDeployHistoryList(filters: SearchType) {
  const activeRealm = useSelector<
    { application: { activeRealm: string } },
    string
  >(state => state.application.activeRealm);

  const { data, isPending, isPlaceholderData } = useQuery({
    queryKey: ['run', 'deployHistoryDistinct', activeRealm, filters],
    queryFn: ({ signal }) =>
      deployHistoryDistinct({
        ...filters,
        realm: activeRealm,
        status: [''],
        signal
      }),
    placeholderData: keepPreviousData,
    enabled: !!activeRealm
  });

  return {
    deployments: data,
    loading: isPending || isPlaceholderData
  };
}
